import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { FormControl } from '../../../../facturotopia';

const ComplementoConceptoVentaVehiculos = () => {

  const handleOnChange = () => {}

  const data = {}

  return (
    <>
      <h5>Complemento Concepto Venta Vehículos</h5>
      <Form autoComplete="off">
        <Row>
          <Col sm md={ 2 }>
            <FormControl type="text"
              label="Clave Vehicular"
              name="ClaveVehicular"
              placeholder=""
              help=""
              minLength="1"
              rules={ ['required', 'string', 'min:1'] }
              value={ data.ClaveVehicular }
              onChange={ handleOnChange }
            />
          </Col>

          <Col sm md={ 2 }>
            <FormControl type="text"
              label="NIV"
              name="Niv"
              placeholder=""
              help=""
              minLength="1"
              rules={ ['required', 'string', 'min:1'] }
              value={ data.Niv }
              onChange={ handleOnChange }
            />
          </Col>
        </Row>

        <h5>Información Aduanera</h5>
        <Row>
          <Col sm md={ 3 }>
            <FormControl type="text"
              label="Número"
              name="numero"
              placeholder=""
              help=""
              minLength="1"
              rules={ ['string', 'min:1'] }
              value={ data.numero }
              onChange={ handleOnChange }
            />
          </Col>

          <Col sm md={ 3 }>
            <FormControl type="text"
              label="Fecha"
              name="fecha"
              placeholder=""
              help=""
              rules={ ['date'] }
              value={ data.fecha }
              onChange={ handleOnChange }
            />
          </Col>

          <Col sm md={ 6 }>
            <FormControl type="text"
              label="Aduana"
              name="aduana"
              placeholder=""
              help=""
              minLength="1"
              rules={ ['string', 'min:1'] }
              value={ data.aduana }
              onChange={ handleOnChange }
            />
          </Col>
        </Row>

        <h5>Parte</h5>
        <Row>
          <Col sm md={ 2 }>
            <FormControl type="number"
              label="Cantidad"
              name="cantidad"
              placeholder=""
              help=""
              rules={ ['required', 'decimal'] }
              value={ data.cantidad }
              onChange={ handleOnChange }
            />
          </Col>

          <Col sm md={ 2 }>
            <FormControl type="text"
              label="Unidad de Medida"
              name="unidad"
              placeholder=""
              help=""
              minLength="1"
              rules={ ['string', 'min:1'] }
              value={ data.unidad }
              onChange={ handleOnChange }
            />
          </Col>

          <Col sm md={ 2 }>
            <FormControl type="text"
              label="Número de Identificación"
              name="noIdentificacion"
              placeholder=""
              help=""
              minLength="1"
              rules={ ['string', 'min:1'] }
              value={ data.noIdentificacion }
              onChange={ handleOnChange }
            />
          </Col>

          <Col sm md={ 2 }>
            <FormControl type="number"
              label="Valor Unitario"
              name="valorUnitario"
              placeholder=""
              help=""
              rules={ ['decimal:6'] }
              value={ data.valorUnitario }
              onChange={ handleOnChange }
            />
          </Col>

          <Col sm md={ 2 }>
            <FormControl type="number"
              label="Importe"
              name="importe"
              placeholder=""
              help=""
              rules={ ['decimal:6'] }
              value={ data.importe }
              onChange={ handleOnChange }
            />
          </Col>
        </Row>

        <Row>
          <Col col={ 3 }>
            <FormControl as="textarea"
              label="Descripción"
              name="descripcion"
              placeholder=""
              help=""
              rows="3"
              minLength="1"
              rules={ ['required', 'string', 'min:1'] }
              value={ data.descripcion }
              onChange={ handleOnChange }
            />
          </Col>

        </Row>
      </Form>
    </>
  );
}

export default ComplementoConceptoVentaVehiculos;